// Pathify
import axios from "axios";
import { make } from "vuex-pathify";
import {
  hasFullMenuAccess,
  hasMenuPermission,
  normalizePermissionPath,
  requiresExplicitPermission
} from "@/util/access";

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  authUser: null,
  items: [
    {
      title: "Dashboard",
      icon: "mdi-view-dashboard",
      to: "/"
    },
    {
      title: "Dashboard Owner",
      icon: "mdi-view-dashboard-outline",
      to: "/dashboard-owner"
    },
    {
      title: "Penerimaan Barang",
      icon: "mdi-clipboard-outline",
      to: "/ttb",
      items: [
        {
          title: "Input / Edit TTB",
          icon: "",
          to: "/ttb/input-edit-ttb"
        },
        {
          title: "TTB Tidak ada Ukuran",
          icon: "",
          to: "/ttb/ttb-tidak-ada-ukuran"
        },
        {
          title: "TTB Tanpa Marketing",
          icon: "",
          to: "/ttb/ttb-tanpa-marketing"
        },
        {
          title: "TTB BLM Stuffing",
          icon: "",
          to: "/ttb/ttb-belum-belum-masuk-container"
        }
      ]
    },
    {
      title: "Container",
      icon: "mdi-truck",
      to: "/container",
      items: [
        {
          title: "Container Full",
          icon: "",
          to: "/container/daftar-container-belum-berangkat"
        },
        {
          title: "Input / Edit Data Container",
          icon: "",
          to: "/container/input-edit-container"
        },
        {
          title: "Packing List",
          icon: "",
          to: "/container/packing-list"
        },
        {
          title: "Cetak KS By Kode Container",
          icon: "",
          to: "/container/cetak-ks-by-kc"
        },
        {
          title: "Laporan Pisah Container",
          icon: "",
          to: "/container/laporan-pisah-container"
        }
      ]
    },
    {
      title: "Vessel",
      icon: "mdi-ferry",
      to: "/data-vessel",
      items: [
        {
          title: "Data Vessel",
          icon: "",
          to: "/vessel/data-vessel"
        },
        {
          title: "Vessel Loading",
          icon: "",
          to: "/vessel/input-data-vessel"
        },
        {
          title: "Master List",
          icon: "",
          to: "/vessel/masterlis"
        }
      ]
    },
    {
      title: "Data Customer",
      icon: "mdi-account-multiple",
      to: "/master-data/customer/"
    },
    {
      title: "Bill of Lading",
      icon: "mdi-text-box",
      to: "/bill-of-lading",
      items: [
        {
          title: "Input Bill of Lading",
          icon: "",
          to: "/bill-of-lading/input-no-bl"
        },
        {
          title: "Cetak Data BL",
          icon: "",
          to: "/bill-of-lading/cetak-data-bl"
        }
      ]
    },
    {
      title: "Penyerahan Cargo",
      icon: "mdi-package-variant-closed",
      to: "/penyerahan-cargo",
      items: [
        {
          title: "TTPB",
          icon: "",
          to: "/penyerahan-cargo/ttpb"
        },
        {
          title: "TTPB Kembali",
          icon: "",
          to: "/penyerahan-cargo/ttpb-kembali"
        },
        {
          title: "TTPB Belum Kembali",
          icon: "",
          to: "/penyerahan-cargo/ttpb-belum-kembali"
        },
        {
          title: "TTPB Kembali Perhari",
          icon: "",
          to: "/penyerahan-cargo/ttpb-kembali-perhari"
        },
        {
          title: "Berita Acara Kembali",
          icon: "",
          to: "/penyerahan-cargo/berita-acara-kembali"
        },
        {
          title: "Berita Acara Dikirim",
          icon: "",
          to: "/penyerahan-cargo/berita-acara-dikirim"
        }
      ]
    },
    {
      title: "Invoice",
      icon: "mdi-receipt",
      to: "/invoice",
      items: [
        {
          title: "List Admin",
          icon: "",
          to: "/invoice/list-admin"
        },
        {
          title: "Input / Edit Invoice",
          icon: "",
          to: "/invoice/input-edit-invoice"
        },
        {
          title: "Print Nota ND / Vessel",
          icon: "",
          to: "/invoice/print-nota-nd"
        },
        {
          title: "Print Nota P / Vessel",
          icon: "",
          to: "/invoice/print-nota-p"
        },
        {
          title: "Print Nota By No Nota",
          icon: "",
          to: "/invoice/print-nota-by-nomor"
        },
        {
          title: "Rekap Nota Per Kapal",
          icon: "",
          to: "/invoice/rekap-nota-per-kapal"
        },
        {
          title: "TTB Belum Ada Nota",
          icon: "",
          to: "/invoice/ttb-belum-ada-nota"
        },
        {
          title: "Penyebaran Nota",
          icon: "",
          to: "/invoice/penyebaran-nota"
        },
        {
          title: "Pelunasan Nota",
          icon: "",
          to: "/invoice/pelunasan-nota"
        },
        {
          title: "Lap Nota Lunas Harian Per Collector",
          icon: "",
          to: "/invoice/laporan-nota-lunas-harian"
        },
        {
          title: "Lap Nota Belum Lunas Per Collector",
          icon: "",
          to: "/invoice/laporan-nota-belum-lunas"
        },
        {
          title: "Lap Nota Belum Lunas Per Customer",
          icon: "",
          to: "/invoice/laporan-belum-lunas-per-customer"
        },
        {
          title: "Lap Tagihan Per Kapal",
          icon: "",
          to: "/invoice/laporan-tagihan-per-kapal"
        },
        {
          title: "Lap Tagihan",
          icon: "",
          to: "/invoice/laporan-omset-tagihan"
        },
        {
          title: "Lap Pemotongan",
          icon: "",
          to: "/invoice/laporan-pemotongan"
        },
        {
          title: "Pemotongan Rekap",
          icon: "",
          to: "/invoice/pemotongan-rekap"
        },
        {
          title: "TTB Belum Invoice",
          icon: "",
          to: "/invoice/ttb-belum-invoice"
        },
        {
          title: "Lap Claim Tanpa LK",
          icon: "",
          to: "/invoice/laporan-claim-tanpa-no-lk"
        }
      ]
    },
    {
      title: "Marketing",
      icon: "mdi-account-tie",
      to: "/marketing",
      items: [
        {
          title: "Laporan Marketing",
          icon: "",
          to: "/invoice/laporan-marketing"
        }
      ]
    },
    {
      title: "Tagihan External",
      icon: "mdi-file-document-outline",
      to: "/tagihan-external",
      items: [
        {
          title: "Input Tagihan Ext",
          icon: "",
          to: "/tagihan-external/input-tagihan"
        },
        {
          title: "Pelunasan Tagihan Ext",
          icon: "",
          to: "/tagihan-external/pelunasan-tagihan"
        },
        {
          title: "Tagihan Ext Belum Lunas",
          icon: "",
          to: "/tagihan-external/tagihan-belum-lunas"
        },
        {
          title: "Laporan Tagihan Ext",
          icon: "",
          to: "/tagihan-external/laporan"
        }
      ]
    },
    {
      title: "Declaring",
      icon: "mdi-clipboard-text",
      to: "/declaring",
      items: [
        { title: "SPK Declaring", icon: "", to: "/declaring/spk" },
        {
          title: "Pelunasan Declaring",
          icon: "",
          to: "/declaring/pelunasan"
        },
        { title: "Laporan Laba Declaring", icon: "", to: "/declaring/laporan" }
      ]
    },
    {
      title: "Laporan Kejadian",
      icon: "mdi-file-document",
      to: "/laporan-kejadian",
      items: [
        {
          title: "Input Laporan",
          icon: "",
          to: "/laporan-kejadian/input-edit-laporan"
        },
        {
          title: "Lihat Laporan",
          icon: "",
          to: "/laporan-kejadian/lihat-laporan"
        },
        {
          title: "Remarks Management",
          icon: "",
          to: "/laporan-kejadian/remarks-management"
        },
        {
          title: "Lap Sudah Remarks",
          icon: "",
          to: "/laporan-kejadian/laporan-sudah-remarks"
        }
      ]
    },
    {
      title: "Giro",
      icon: "mdi-cash-100",
      to: "/giro",
      items: [
        {
          title: "Edit Status Giro",
          icon: "",
          to: "/giro/edit-status-giro"
        },
        {
          title: "Laporan Giro Belum Cair",
          icon: "",
          to: "/giro/laporan-giro-belum-cair"
        },
        {
          title: "Laporan Giro Sudah Cair",
          icon: "",
          to: "/giro/laporan-giro-sudah-cair"
        }
      ]
    },
    {
      title: "Kasir",
      icon: "mdi-cash",
      to: "/kasir",
      items: [
        {
          title: "Biaya Buruh",
          icon: "",
          to: "/kasir/biaya-buruh"
        },
        {
          title: "Biaya Truk",
          icon: "",
          to: "/kasir/biaya-truk"
        },
        {
          title: "Pengeluaran Kas",
          icon: "",
          to: "/kasir/pengeluaran-kas"
        },
        {
          title: "Lap Pengeluaran Kas (Tanggal)",
          icon: "",
          to: "/kasir/laporan-pengeluaran-kas-tanggal"
        },
        {
          title: "Lap Pengeluaran Kas (POS)",
          icon: "",
          to: "/kasir/laporan-pengeluaran-kas-pos"
        },
        {
          title: "Rincian Pengeluaran Kas (Periode)",
          icon: "",
          to: "/kasir/rincian-pengeluaran-kas"
        },
        {
          title: "Lap Biaya Buruh Harian",
          icon: "",
          to: "/kasir/laporan-biaya-buruh"
        },
        {
          title: "Lap Biaya Truk Harian",
          icon: "",
          to: "/kasir/laporan-biaya-truk"
        },
        {
          title: "Lap Biaya Lain Harian",
          icon: "",
          to: "/kasir/laporan-biaya-lain"
        },
        {
          title: "Lap Kasir",
          icon: "",
          to: "/kasir/laporan-pengeluaran-keseluruhan"
        },
        {
          title: "Major Lap Harian Kasir",
          icon: "",
          to: "/kasir/major-lap-harian-kasir"
        }
      ]
    },
    {
      title: "Master Data",
      icon: "mdi-database",
      to: "/master-data",
      items: [
        {
          title: "Kategori Pengeluaran",
          icon: "",
          to: "/master-data/kategori-pengeluaran"
        },
        {
          title: "Kategori Lap. Kejadian",
          icon: "",
          to: "/master-data/kategori-laporan"
        },
        {
          title: "Kategori Tagihan",
          icon: "",
          to: "/master-data/kategori-tagihan"
        },
        {
          title: "Nama Penagih",
          icon: "",
          to: "/master-data/penagih"
        },
        {
          title: "Saldo Awal",
          icon: "",
          to: "/master-data/saldo-awal"
        }
      ]
    },
    {
      title: "Admin",
      icon: "mdi-account-lock",
      to: "/admin",
      items: [
        {
          title: "Kelola Karyawan",
          icon: "",
          to: "/admin/kelola-karyawan"
        },
        {
          title: "Hapus TTB",
          icon: "",
          to: "/admin/hapus-ttb"
        },
        {
          title: "Hapus Container",
          icon: "",
          to: "/admin/hapus-container"
        },
        {
          title: "Hapus Nota",
          icon: "",
          to: "/admin/hapus-nota"
        },
        {
          title: "Hapus Biaya Buruh",
          icon: "",
          to: "/admin/hapus-biaya-buruh"
        },
        {
          title: "Hapus Biaya Truk",
          icon: "",
          to: "/admin/hapus-biaya-truk"
        },
        {
          title: "Hapus Biaya Lain",
          icon: "",
          to: "/admin/hapus-biaya-lain"
        },
        {
          title: "Setting Variable",
          icon: "",
          to: "/admin/setting-variable"
        }
      ]
    }
    // {
    //   title: 'Laporan',
    //   icon: 'mdi-file',
    //   to: '/laporan',
    //   items: [

    //   ]
    // },
    // {
    //   title: 'Cetak',
    //   icon: 'mdi-printer',
    //   to: '/cetak',
    //   items: [
    //     {
    //       title: 'Nota Penagihan',
    //       icon: '',
    //       to: '/cetak/nota-penagihan'
    //     }
    //   ]
    // },
  ]
};

const mutations = make.mutations(state);

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    dispatch("syncAuthUser");
  },
  syncAuthUser: async ({ commit }) => {
    let localUser = {};
    try {
      localUser = JSON.parse(localStorage.getItem("user") || "{}");
    } catch (e) {
      localUser = {};
    }
    commit("authUser", localUser);

    const token = localStorage.getItem("token");
    if (!token || !localUser || !localUser.user_id) return;

    try {
      const res = await axios.get(`karyawan/${localUser.user_id}`);
      if (res && res.data && res.data.user_id) {
        const updatedUser = {
          ...localUser,
          ...res.data
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        commit("authUser", updatedUser);
      }
    } catch (e) {
      // Keep local user if background sync fails
    }
  }
};

const getters = {
  items: state => {
    let user = state.authUser;
    if (!user || !Object.keys(user).length) {
      try {
        user = JSON.parse(localStorage.getItem("user") || "{}");
      } catch (e) {
        user = {};
      }
    }
    if (hasFullMenuAccess(user))
      return state.items;

    let perms = user.permissions;
    if (typeof perms === "string") {
      try {
        perms = JSON.parse(perms);
      } catch (e) {
        perms = null;
      }
    }
    const normalizedPerms = Array.isArray(perms)
      ? perms.map(normalizePermissionPath)
      : [];
    const withoutAdminDefault = state.items.filter(
      i => i.title !== "Admin" && !requiresExplicitPermission(i.to)
    );
    if (!Array.isArray(perms) || perms.length === 0) return withoutAdminDefault;

    return state.items.reduce((acc, i) => {
      if (!i.items) {
        if (
          normalizePermissionPath(i.to) === "/" ||
          hasMenuPermission(normalizedPerms, i.to)
        ) {
          acc.push(i);
        }
        return acc;
      }
      const subs = i.items.filter(s =>
        hasMenuPermission(normalizedPerms, s.to)
      );
      if (subs.length) acc.push({ ...i, items: subs });
      return acc;
    }, []);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
